import style from './Content.styl';

export function Content({ children }) {
  return (
    <div className={style.content}>
      {children}
    </div>
  );
}
